export const mainNav = [
  { to: '/boutique', label: 'Boutique', mega: true },
  { to: '/createurs', label: 'Créateurs', mega: false },
  { to: '/concept', label: 'Le concept', mega: false },
];

export const shopShortcuts = [
  { to: '/boutique', label: 'Toute la boutique' },
  { to: '/boutique?tri=new', label: 'Nouveautés' },
  { to: '/boutique?derniers=1', label: 'Derniers jours' },
  { to: '/boutique?unique=1', label: 'Pièces uniques' },
];

export const footerNav = [
  {
    title: 'Boutique',
    links: [
      { to: '/boutique?categorie=bijoux', label: 'Bijoux & accessoires' },
      { to: '/boutique?categorie=mode', label: 'Mode & textile' },
      { to: '/boutique?categorie=deco', label: 'Décoration & artisanat' },
      { to: '/boutique?categorie=local', label: 'Produits locaux' },
    ],
  },
  {
    title: 'La maison',
    links: [
      { to: '/createurs', label: 'Les créateurs' },
      { to: '/createurs?vue=calendrier', label: 'Calendrier des vitrines' },
      { to: '/concept', label: 'Le concept' },
      { to: '/concept#candidature', label: 'Exposer chez nous' },
    ],
  },
  {
    title: 'Aide',
    links: [
      { to: '/panier', label: 'Mon panier' },
      { to: '/favoris', label: 'Mes favoris' },
      { to: '/concept#visite', label: 'Retrait en boutique' },
      { to: '/concept#visite', label: 'Nous contacter' },
    ],
  },
];
